import Header from "@/components/Header";
import { Footer2 } from "@/components/ui/shadcnblocks-com-footer2";
import PageTransition from "@/components/PageTransition";
import { SEO } from "@/components/SEO";

const Shipping = () => {
  return (
    <PageTransition>
      <SEO
        title="מדיניות משלוחים"
        description="מדיניות משלוחים של אליס תכשיטים - משלוח עד הבית, איסוף עצמי, זמני אספקה ועלויות. משלוחים לכל רחבי הארץ"
        canonical="https://gemini-design-shop.lovable.app/shipping"
        breadcrumbs={[
          { name: 'דף הבית', url: '/' },
          { name: 'מדיניות משלוחים', url: '/shipping' },
        ]}
      />
      <div className="min-h-screen flex flex-col" dir="rtl">
        <Header />
        
        <main className="flex-1">
          <section className="py-16 px-4">
            <div className="container mx-auto max-w-4xl">
              <div className="text-center mb-12 animate-fade-in">
                <div className="gold-divider mb-6" />
                <h1 className="text-4xl md:text-5xl font-serif mb-4">מדיניות משלוחים</h1>
              </div>

              <div className="space-y-8 text-right animate-fade-in" style={{ animationDelay: '0.1s' }}>
                <div>
                  <h2 className="text-2xl font-serif mb-4">שליח עד הבית</h2>
                  <div className="space-y-4 text-muted-foreground">
                    <p className="leading-relaxed">
                      משלוחים לישובים חריגים עשויים להתעכב עד 12 ימי עסקים. ניתן למצוא את רשימת הישובים החריגים באתר דואר ישראל.
                    </p>
                    <p className="leading-relaxed">
                      לאחר קליטת המשלוח בחברת השליחויות ייצרו עמכם קשר במספר שהזנתם בעת ביצוע ההזמנה לתיאום מועד וטווח השעות המועדף עליכם לקבלת המשלוח.
                    </p>
                    <p className="leading-relaxed">
                      מסירת המשלוחים מתבצעת בימים א'-ה' בין השעות 08:00-19:00 וביום ו' בין השעות 08:00-12:00. חברת המשלוחים תיצור עמכם קשר על מנת לתאם את שעת מסירת החבילה.
                    </p>
                    <p className="leading-relaxed font-semibold text-foreground">
                      בישובים שאינם חריגים, זמני אספקה משוערים בד"כ הינם 2-5 ימי עסקים מיום ביצוע ההזמנה באתר.
                    </p>
                  </div>
                </div>

                <div className="pt-4">
                  <h2 className="text-2xl font-serif mb-4">איסוף עצמי</h2>
                  <div className="space-y-4 text-muted-foreground">
                    <p className="leading-relaxed">
                      הזמנות ניתן לאסוף בשלב זה רק בסניף הראשי, ברחוב הרצל 58, באר שבע, בשעות הפעילות.
                    </p>
                    <p className="leading-relaxed font-semibold text-foreground">
                      יש להגיע לאיסוף ההזמנה אך ורק לאחר קבלת מייל המאשר כי ההזמנה מוכנה לאיסוף.
                    </p>
                    <p className="leading-relaxed">
                      בנוסף ניתן לתאם איסוף מול שירות הלקוחות בטלפון 079-5575576 או במייל: info@alicejewelry.net
                    </p>
                  </div>
                </div>

                <div className="bg-muted/30 p-6 rounded-lg">
                  <h3 className="text-xl font-semibold mb-4">הערות נוספות:</h3>
                  <ul className="space-y-3 text-muted-foreground text-sm">
                    <li>• הזמנה שהתקבלה לאחר השעה 15:00 או בערב חג/יום שישי תטופל כהזמנה שהתקבלה ביום העסקים הבא.</li>
                    <li>
                      • הזמנות במידה מותאמת אישית, כגון, טבעות (נישואין/אירוסין) ובכלל, הזמנת טבעות נישואין: זמן האספקה ישתנה בהתאם לזמן הייצור של היצרן ואספקתו לחברה. לכל היותר עד 21 ימי עסקים.
                    </li>
                    <li>• במידה וייתכן עיכוב בהזמנה מכל סיבה שהיא אנו נדאג ליידע אתכן\ם על כך.</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer2 />
      </div>
    </PageTransition>
  );
};

export default Shipping;
